__turbopack_context__.v({
  "ErrorMessage": "SelectInput-module-scss-module__zKSMLq__ErrorMessage",
  "InputLabel": "SelectInput-module-scss-module__zKSMLq__InputLabel",
  "RequiredIndicator": "SelectInput-module-scss-module__zKSMLq__RequiredIndicator",
});
